import { EnormousFileUploadMessage, IconGroup } from '../Types/Notifications.types';
import { AppDispatch } from '../../app/store';
import { fetchNotificationsByEventGroup, setNewNotification } from '../Slices/Notifications.slice';
import { Messages } from '../../Constants/Messages';
import { fetchEnormousFileUploadsData, setEnormousFileUpload } from '../../pages/admin/Lists/EnormousFileUploads/EnormousFileUploads.slice';
import { showSuccessSnackbar } from '../../component/snackbar/Snackbar.slice';

export function addEnormousFileUploadSuccessNotification(
	enormousFileUploadMessage: EnormousFileUploadMessage,
	dispatch: AppDispatch,
) {
	dispatch(fetchNotificationsByEventGroup(IconGroup.EnormousFileUpload));
	showSuccessSnackbar(dispatch, Messages.ENORMOUS_FILE_UPLOAD_SUCCESS);
	dispatch(setEnormousFileUpload(true));
	dispatch(setNewNotification());
	dispatch(fetchEnormousFileUploadsData());
}

export function addEnormousFileUploadFailureNotification(
	enormousFileUploadMessage: EnormousFileUploadMessage,
	dispatch: AppDispatch,
) {
	dispatch(setEnormousFileUpload(true));
	dispatch(fetchNotificationsByEventGroup(IconGroup.EnormousFileUpload));
	dispatch(setNewNotification());
	dispatch(fetchEnormousFileUploadsData());
}
